import { render, staticRenderFns } from "./PaymentHighlights.vue?vue&type=template&id=3b58431b"
import script from "./PaymentHighlights.vue?vue&type=script&lang=js"
export * from "./PaymentHighlights.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports